<template>
    <div class="container-fluid p-0 fondo-gris" style="padding: 0 !important; margin: 0 !important;">
        <!-- Layout V1
            <div class="titulo">
            <h1>NOTICIAS</h1>
        </div>
        <CNoSeEncontraronResultados class="mt-4" v-if="!this.campoRequeridoEsValido(noticias)" :opciones="{ tituloBusqueda: 'Búsqueda en noticias', NombreSeccion: 'Noticias' }"></CNoSeEncontraronResultados>
        <div v-show="this.campoRequeridoEsValido(noticias)" class="mt-4">
            <div class="row d-flex justify-content-center">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pl-0 pr-0 pt-1" v-if="mostrarCarrusel">
                    <div id="carrusel">
                        <carousel 
                            :autoplay="opciones.configuraciones.autoPlay" 
                            :responsive="opciones.configuraciones.dimensiones">
                            <div v-for="(noticia,index) in noticias" :key="'img' + index" class="contenedor-noticia">
                                <div @click="descargarArchivoDeNoticia({ contenidoId: noticia.id })" class="contenedor-imagenes">
                                    <img :style="opciones.configuraciones.estilosCss" :src="noticia.RutaDeAcceso" alt="img1" >
                                </div>
                                <div style="cursor: pointer;" @click="verNoticia({ contenidoId: noticia.id })" class="noticia-descripcion text-justify">
                                    <h1><i class="fas fa-info-circle"></i>&nbsp;{{ noticia.Titulo }}</h1>
                                    <h2 v-html="ajustarTexto({ textoParaAjustar : noticia.Descripcion, numeroDeCaracteres: 180 })"></h2>
                                </div>
                            </div>
                        </carousel>
                    </div>
                </div>
            </div>
            <div id="acciones-noticias" class="d-flex justify-content-end">
                <button class="btn btn-primary" @click="irANoticias">Ver Mas</button>
            </div>
        </div> -->
        <!-- LAYOUT V2 -->
        <CNoSeEncontraronResultados class="mt-4" v-if="!this.campoRequeridoEsValido(noticias)" :opciones="{ tituloBusqueda: 'Búsqueda en noticias', NombreSeccion: 'Noticias' }"></CNoSeEncontraronResultados>
        <div class="contenedor-imagenes-v2" v-if="mostrarCarrusel">
            <carousel 
                :autoplay="opciones.configuraciones.autoPlay" 
                :responsive="opciones.configuraciones.dimensiones"
                :autoplayTimeout="10000">
                <div v-for="(noticia,index) in noticias" :key="'img' + index">
                    <div @click="descargarArchivoDeNoticia({ contenidoId: noticia.id })">
                        <img :style="opciones.configuraciones.estilosCss" :src="noticia.RutaDeAcceso" alt="img1" >
                    </div>
                    <div style="cursor: pointer;" @click="verNoticia({ contenidoId: noticia.id })" class="noticia-descripcion-v2 text-justify">
                        <h1><i class="fas fa-info-circle"></i>&nbsp;{{ noticia.Titulo }}</h1>
                        <h2 v-html="ajustarTexto({ textoParaAjustar : noticia.Descripcion, numeroDeCaracteres: 180 })"></h2>
                    </div>
                </div>
            </carousel>
            <div id="acciones-noticias" class="acciones-imagen">
                <button class="btn btn-primary" @click="irANoticias">Ver Mas</button>
            </div>
        </div>
        <hr class="hr-separacion" />
        <!-- MODAL NOTICIA -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="detalles-noticia-intranet">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content" v-if="this.campoRequeridoEsValido(noticiaSeleccionada)">
                    <div class="modal-header">
                        <h5 class="modal-title">Detalles noticia</h5>
                        <button id="btn-cerrar-detalles-noticia-intranet" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div class="modal-body pl-4 pr-4">
                        <div id="titulo-noticia" class="text-right">
                            <h4>{{ noticiaSeleccionada.Titulo }}</h4>
                            <h6>{{ noticiaSeleccionada.Fecha }}</h6>
                        </div>
                        <div id="imagen-noticia">
                            <img style="height: 250px" :src="noticiaSeleccionada.RutaDeAcceso" alt=""/>
                        </div>
                        <div id="contenido-noticia" class="mt-4 text-justify">
                            <h6 v-html="noticiaSeleccionada.Descripcion"></h6>
                        </div>
                        <div id="acciones-noticias" class="d-flex justify-content-end">
                            <button @click="descargarArchivoDeNoticia({ contenidoId: noticiaSeleccionada.id })" class="btn btn-primary">Descargar</button>
                        </div>
                    </div>            
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import router from '@/router/index'
import carousel from 'vue-owl-carousel'
import api from '@/../static/js/api'
import CNoSeEncontraronResultados from '../Comun/CNoSeEncontraronResultados.vue'

export default {
    components: {
        carousel: carousel,
        CNoSeEncontraronResultados: CNoSeEncontraronResultados
    },
    props: {
        noticias: {
            type: Array,
            default: () => []
        },
        opciones: {
            type: Object,
            default: () => ({ 
                conFondo: false,
                configuraciones: { 
                    autoPlay: false,
                    dimensiones: { 
                        0: { items: true, nav: false }, 
                        600:{ items: true, nav: false },
                        800: { items: true, nav: false },
                        1200: { items: true, nav: false }
                    },
                    estilosCss: 'height: 30em; border-radius: 10px 10px 10px 10px;'
                 } 
            })
        },
    },
    data() {
        return {
            noticiaSeleccionada: null
        }
    },
    methods: {
        descargarArchivoDeNoticia: function({ contenidoId }) { debugger
            this.noticiaSeleccionada = this.noticias.find(noticia => noticia.id == contenidoId);
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.href = `${api.conexion}${api.Comun.funcion.DescargarArchivo}?rutaDelArchivo=${this.noticiaSeleccionada.RutaDeArchivo}`
            a.click();
        },
        ajustarTexto: function({ textoParaAjustar, numeroDeCaracteres }) { debugger
            let textoAjustado = textoParaAjustar;
            if(this.campoRequeridoEsValido(textoParaAjustar) && this.campoRequeridoEsValido(numeroDeCaracteres)) {
                const LONGITUD_TEXTO = textoParaAjustar.length;
                if(LONGITUD_TEXTO > numeroDeCaracteres) {
                    textoAjustado = `${ textoAjustado.substring(0,numeroDeCaracteres) } ...`;
                }
            }
            return textoAjustado;   
        },
        verNoticia: function({ contenidoId }) {
            this.noticiaSeleccionada = this.noticias.find(noticia => noticia.id == contenidoId);
            if(this.campoRequeridoEsValido(this.noticiaSeleccionada)) {
                $("#detalles-noticia-intranet").modal('show');
            }
            else {
                alert('Ocurrio un error al cargar la noticia, vuelve a intentarlo.')
            }
        },
        irANoticias: function() {
            router.push({ name: "Comunicados" });
        },
        campoRequeridoEsValido: function(campo) { 
            let esValido = false
            if(typeof campo === 'string' || campo instanceof String) {
                // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
                if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'number' || campo instanceof Number) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo > 0) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'array' || campo instanceof Array) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo.length > 0) {
                    esValido = true;
                }
            }
            else {
                if (campo != null && campo != undefined) {
                    esValido = true;
                }
            }
            return esValido;
        }
    },
    computed: {
        mostrarCarrusel() {
            return (this.campoRequeridoEsValido(this.noticias));
        }
    }
}
</script>
<style scoped>
.contenedor-imagenes-v2 {
    margin: 0 !important;
    padding: 0 !important;
    position: relative;
}

.noticia-descripcion-v2 {
    width: 30%;
    height: 34%;
    max-height: 35%;
    position: absolute;
    background-color: rgb(250, 250, 250);
    top: 55%;
    left: 50px !important; 
    padding: 0.8em 1.3em 0.8em 1.3em;
    overflow: auto;
    border-radius: 10px 10px 10px 10px;
    border: 2px solid black;
    opacity: 0.8;
}

.noticia-descripcion-v2:hover {
    opacity: 1;
    width: 31%;
    height: 35%;
    max-height: 36%;
}

.acciones-imagen {
    position: relative;
    width: 100px;
    z-index: 1;
    top: -50px;
    left: calc(100% - 140px);
}

.hr-separacion {
    border: 0.1px solid rgb(189, 188, 188) !important;
    margin: -20px 20% -20px 20%;
}

.noticia-descripcion-v2 h1 {
    font-size: 1.5em;
    font-weight: bold;
    color: black;
}

.noticia-descripcion-v2 h2 {
    font-size: 1em;
}

.contenedor-imagen-v2 {
    padding-bottom: 0 !important;
    margin-bottom:  0 !important;
}

#acciones-noticias .btn-primary {
    background-color: black;
}

#acciones-noticias .btn-primary:focus, #acciones-noticias .btn-primary:hover {
    color: #be9a5e;
}

#contenido-noticia {
    max-height: 130px;
    overflow: auto;
    margin-bottom: 2em;
}

/* #contenido-noticia {
    max-height: 300px;
    overflow: auto;
}
 */
#imagen-noticia {
    cursor: pointer;
}

#titulo-noticia h4 {
    font-weight: bold;
    margin-bottom: 0;
}

#titulo-noticia h6 {
    color: gray;
}

#detalles-noticia-intranet .modal-lg {
    max-width: 50% !important;
    z-index: 9999999999999999999999999999999999999;
}

#detalles-noticia-intranet .modal-content {
    background-color: #FFFFFF;
    box-shadow: 0px 6px 20px 8px #424242;;
}

#detalles-noticia-intranet .modal-header {
    background-color: rgb(0, 0, 0);
    border: none;
    color: white;
}

/* #detalles-noticia-intranet .modal-dialog {
  position: relative;
  top: 40%;
  transform: translateY(-50%);
} */

.noticia-descripcion {
    width: 70%;
    height: 30%;
    max-height: 35%;
    position: absolute;
    background-color: white;
    top: 63%;
    left: 60% !important; 
    transform: translate(-50%,0);
    padding: 0.8em 1.3em 0.8em 1.3em;
    overflow: auto;
    border-radius: 10px 10px 10px 10px;
    opacity: 0.8;
    border: 1px solid black;
}

.noticia-descripcion h1 {
    font-size: 1.5em;
    font-weight: bold;
    color: black;
}

.noticia-descripcion h2 {
    font-size: 1em;
}


.contenedor-noticia {
    position: relative;
    height: 33em;
    margin: 0 !important;
    padding:  0 !important;
}

#acciones-noticias .btn-primary {
    background-color: black;
}

#acciones-noticias .btn-primary:focus, #acciones-noticias .btn-primary:hover{
    color: #be9a5e;
}

.titulo h1 {
    font-size: 3.5em;
    font-weight: bold;
    text-align: center;
    text-shadow: 1px 3px #5f5f5f;
}

.fondo-gris {
   /*  padding-top: 2em !important;
    padding-left: 4em !important;
    padding-right: 4em !important;
    padding-bottom: 2em !important;
    background-color: rgb(180, 180, 180); */
}

.titulo-imagen {
   margin-top: 1em;
   font-family: 'AntenaBeta';
   font-size: 2em;
   font-weight: bold;
}

.contenedor-imagenes{
  margin:10px;
  border: 2px solid black;
  border-radius: 10px 10px 10px 10px;
  position: absolute;
  cursor: pointer;
  box-shadow: 2px 2px 6px 6px #383838;
  width: 97%;
}

.imagen-carrusel{
  height: 33em;
  border-radius: 10px 10px 10px 10px;
}

</style>


// WEBPACK FOOTER //
// src/components/Intranet/Formatos/CComunicados.vue